import {
  Autocomplete,
  Avatar,
  Card,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { formatDistance } from "date-fns";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useGetCryptoNewsQuery } from "../../services/cryptoNewsApi";
import { useGetRapidCryptoQuery } from "../../services/RapidCryptoApi";
import { loadingActions } from "../../store/loading-slice";
import LoadingPage from "../LoadingScreen";

const NewsComponent = ({ shortView }) => {
  const [newsCategory, setNewsCategory] = useState("Bitcoin");
  const dispatch = useDispatch();
  const count = shortView ? 6 : 12;
  const {
    data: cryptoNews,
    isFetching,
    isSuccess,
  } = useGetCryptoNewsQuery({
    newsCategory,
    count,
  });

  const demoImage =
    "https://www.bing.com/th?id=OVFT.mpzuVZnv8dwIMRfQGPbOPC&pid=News";

  const { data: cryptoLists, isFetching: cryptoFetching } =
    useGetRapidCryptoQuery(100);

  if (isFetching || cryptoFetching) {
    dispatch(loadingActions.openHandler());
    return <LoadingPage />;
  }
  if (isSuccess) {
    dispatch(loadingActions.closeHandler());
  }
  return (
    <Grid container direction="column">
      {!shortView && (
        <Grid
          item
          sx={{
            mx: {
              xs: "auto",
              md: 2,
            },
          }}
        >
          <Grid item container>
            <Autocomplete
              value={newsCategory}
              disablePortal
              onChange={(event, newValue) => {
                setNewsCategory(newValue);
              }}
              id="combo-box-demo"
              options={cryptoLists?.data?.coins.map((item) => item.name)}
              sx={{
                width: {
                  xs: "200px",
                  sm: "300px",
                },
              }}
              renderInput={(params) => (
                <TextField
                  sx={{ bgcolor: "white" }}
                  {...params}
                  InputLabelProps={{ sx: { fontWeight: 500 } }}
                  label="Select a Crypto"
                />
              )}
            />
          </Grid>
        </Grid>
      )}

      <Grid item container spacing={4} sx={{ mt: 2 }}>
        {cryptoNews?.value.map((news) => (
          <Grid item xs={12} sm={6} key={news.name} lg={4}>
            <a href={news.url} target="_blank" rel="noreferrer">
              <Card
                component="article"
                sx={{
                  pl: 2,
                  height: {
                    xs: "auto",
                    sm: "25rem",
                    md: "20rem",
                    xl: "18rem",
                  },
                }}
              >
                <Grid container item direction="column" sx={{ pt: 2 }}>
                  <Grid item>
                    <Grid item container>
                      <Grid item xs={8}>
                        <Typography
                          sx={{
                            fontSize: "1.2rem",
                            fontWeight: 600,
                            overflowWrap: "break-word",
                          }}
                        >
                          {news.name.length > 100
                            ? `${news.description.substring(0, 60)}...`
                            : news.name}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        container
                        xs={4}
                        justifyContent="flex-end"
                        sx={{ pr: 4 }}
                      >
                        <Avatar
                          variant="square"
                          sx={{
                            width: {
                              xs: 120,
                              sm: 50,
                              md: 80,
                            },
                            height: {
                              xs: 100,
                              sm: 70,
                            },
                          }}
                          src={news?.image?.thumbnail?.contentUrl || demoImage}
                          alt="news"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <Grid item container>
                      <Grid item sx={{ mt: "1.5rem" }}>
                        <Typography variant="body2" align="center">
                          {news.description.length > 300
                            ? `${news.description.substring(0, 100)}...`
                            : news.description}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item sx={{ mt: "auto" }}>
                    <Grid
                      item
                      container
                      justifyContent="space-between"
                      sx={{ mt: 1 }}
                    >
                      <Grid item>
                        <Avatar
                          src={
                            news.provider[0]?.image?.thumbnail?.contentUrl ||
                            demoImage
                          }
                          alt="something"
                        />
                        <Typography variant="body2" align="center">
                          {news.provider[0]?.name}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography variant="body2">
                          {formatDistance(
                            new Date(),
                            new Date(news.datePublished),
                            { includeSeconds: true }
                          )}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </a>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default NewsComponent;
